export default __webpack_public_path__ + "static/media/html.71b1be1b.svg";